export const formatCurrency = (amount: string | number): string => {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (isNaN(num)) {
    return '$0.00';
  }
  return `$${num.toFixed(2)}`;
};

export const calculateInvoiceTotal = (fee: string | number, receiptsCopyCosts: string | number): string => {
  const feeAmount = typeof fee === 'string' ? parseFloat(fee || '0') : (fee || 0);
  const receiptsAmount = typeof receiptsCopyCosts === 'string' ? parseFloat(receiptsCopyCosts || '0') : (receiptsCopyCosts || 0);
  return (feeAmount + receiptsAmount).toFixed(2);
}; 